import React from "react";
import { useSelector } from "react-redux";
import { IonItem, IonLabel } from "@ionic/react";
// Selectors
import UserAvatar from "../../../components/UserAvatar";
import { selectFindMessagesStatus } from "../../../store/paymentNoticeDetail/selectors/selectFindMessagesStatus";
import { selectItemMessages } from "../../../store/paymentNoticeDetail/selectors/selectItemMessages";
import { ArchiveItem } from "./ArchiveItem";

export const PaymentNoticeMessages: React.FC = () => {
  const messages = useSelector(selectItemMessages);
  const findMessagesStatus = useSelector(selectFindMessagesStatus);
  return (
    <section>
      <section style={{ fontWeight: 200 }}>
        {findMessagesStatus === "pending" && (
          <p className="ion-text-center">Cargando actividad....</p>
        )}
        {findMessagesStatus === "rejected" && (
          <p className="ion-text-center">Ha ocurrido un error</p>
        )}
        {findMessagesStatus === "fulfilled" && messages.length === 0 && (
          <p className="ion-text-center">No se ha registrado actividad</p>
        )}
      </section>

      {messages &&
        messages.map((message, index) => (
          <article key={index}>
            <IonItem lines="inset">
              <UserAvatar />
              <IonLabel class="ion-text-wrap">
                <h2>
                  <strong>{message.createdBy?.name}</strong> escribió
                </h2>
                <h2 style={{ paddingTop: "8px" }}>{message.text}</h2>
                <h4
                  style={{
                    display: "flex",
                    scrollSnapType: "x mandatory",
                    overflow: "auto",
                  }}
                >
                  {message.attachmentArchives.map((archive, index) => (
                    <ArchiveItem
                      archive={archive}
                      key={index}
                      editable={false}
                    />
                  ))}
                </h4>
                <p className="ion-text-end">
                  <strong>{message.createdAtLegible}</strong>
                </p>
              </IonLabel>
            </IonItem>
          </article>
        ))}
    </section>
  );
};
